var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getThemeConfig.layout === 'defaults')?_c('Defaults'):(_vm.getThemeConfig.layout === 'classic')?_c('Classic'):(_vm.getThemeConfig.layout === 'transverse')?_c('Transverse'):(_vm.getThemeConfig.layout === 'columns')?_c('Columns'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }